import React from 'react'
import { Container, SocialMedia } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'

const MainContent = ({profile}) => {
  const {
    content = '-',
    socialLinks = []
  } = profile

  return (
    <Container className="pt-10 pb-10 lg:pt-16 lg:pb-16">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-9/12 px-4">
          <h4 className="uppercase font-bold text-lg mb-3 lg:mb-5">About Me</h4>
          {
            content && content !== null ?
            <div
              className="blog-content break-words lg:pr-16"
              dangerouslySetInnerHTML={{__html: content}}
              style={{whiteSpace: 'pre-line'}}
            /> : <>-</>
          }
        </div>
        <div className="w-full lg:w-3/12 px-4 mt-5 lg:mt-0">
          <SystemProvider>
            <SocialMedia data={socialLinks} leftOnMobile={true}/>
          </SystemProvider>
        </div>
      </div>
    </Container>
  )
}

export { MainContent }
